import { useEffect } from 'react';
import { UploadInvoiceForm } from 'components';
import { useOktaAuth } from '@okta/okta-react';


export default function TestDebugUserPage() {

    const oktaAuth = useOktaAuth()

    console.log({oktaAuth})
    useEffect(() => {
        if(oktaAuth?.authState) {
            var dataToExport = {
                authState: oktaAuth.authState,
            }
            const json = JSON.stringify(dataToExport, null, 2); // pretty-print with 2 spaces
            const blob = new Blob([json], { type: "application/json" });
            const url = URL.createObjectURL(blob);
        
            const link = document.createElement("a");
            link.href = url;
            link.download = "user-data.json";
            document.body.appendChild(link);
            link.click();
        
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }, [oktaAuth])


    return (
        <div>
            <h3>Exporting user information...</h3>
            <h5>Please provide the downloaded file to IT. Thank you.</h5>
        </div>
    )
}